import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SecurityData } from '@repo/user-types'

const initialState: SecurityData = {
  username: '',
  newPassword: '',
  oldPassword: '',
  passwordConfirmation: '',
}

export const { actions: securityDataActions, reducer: securityDataReducer } = createSlice({
  initialState,
  name: '@users/security/data',
  reducers: {
    updateField: (state, action: PayloadAction<{ field: keyof SecurityData; value: string }>) => {
      return {
        ...state,
        [action.payload.field]: action.payload.value,
      }
    },
    setData: (state, action: PayloadAction<Partial<SecurityData>>) => {
      return {
        ...state,
        ...action.payload,
      }
    },
    clean: () => initialState,
  },
})
